import ky from 'ky';
import { ErrorResult, ServerResult } from './ApiResults';
import store from '../store';

function getAuthHeader() {
    return { headers: { Authorization: `Bearer ${store.state.user.token}` } };
}

const addCommhubUrl = (url) => {
    return process.env.VUE_APP_COMMHUB_URL + url;
};


export class SecKy {
    static getUrlBase() {
        return addCommhubUrl(''); 
    } 

    static async get(url, object) {
        if (!url)
            return new ErrorResult("HttpClient requires url");

        let response;
        try {
            response = await ky.get(addCommhubUrl(url), { ...object, ...getAuthHeader(), timeout: 120000 });
        }
        catch(e) {
            return new ErrorResult(e.toString(), e);
        }
        var result = new ServerResult(response);
        await result.tryReadJson()
        
        return result;
    }
    static async post (url, object) {
        if (!url)
            return new ErrorResult("HttpClient requires url");

        let response;
        try {
                response = await ky.post(addCommhubUrl(url), { ...object, ...getAuthHeader(), timeout: 120000 });
        }
        catch(e) {
            return new ErrorResult(e.toString(), e);
        }

        var result = new ServerResult(response);
        await result.tryReadJson()
        
        return result;
    }
    static async put (url, object) {
        if (!url)
            return new ErrorResult("HttpClient requires url");

        let response;
        try {
                response = await ky.put(addCommhubUrl(url), { ...object, ...getAuthHeader(), timeout: 120000 });
        }
        catch(e) {
            return new ErrorResult(e.toString(), e);
        }

        var result = new ServerResult(response);
        await result.tryReadJson()
        
        return result;
    }
    static async delete (url, object) {
        if (!url)
            return new ErrorResult("HttpClient requires url");

        let response;
        try {
             response = await ky.delete(addCommhubUrl(url), { ...object, ...getAuthHeader(), timeout: 120000 });
        }
        catch(e) {
            return new ErrorResult(e.toString(), e);
        }

        var result = new ServerResult(response);
        await result.tryReadJson()
        
        return result;
    }
}

